module.exports = __webpack_public_path__ + "app-static/img/null3.c4eedc46.png";